import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { Action } from 'redux';
import {
  CreateOnboardingLink,
  CreateConnectedAccountSuccess,
} from '../action-creators';
import { CREATE_CONNECTED_ACCOUNT_SUCCESS } from '../actions';

export const getOnboardingLinkAfterCreateEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, CreateConnectedAccountSuccess>(
      CREATE_CONNECTED_ACCOUNT_SUCCESS
    ),
    map((action) => new CreateOnboardingLink(action.account.id))
  );
